"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TychoMagnetics = void 0;
const Resources_1 = require("../../Resources");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const HiTechLab_1 = require("../promo/HiTechLab");
const Size_1 = require("../render/Size");
class TychoMagnetics extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.TYCHO_MAGNETICS,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.SCIENCE],
            startingMegaCredits: 42,
            metadata: {
                cardNumber: '??',
                description: 'You start with 42 M€. Increase your energy production 1 step.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.production((pb) => pb.energy(1)).nbsp().megacredits(42);
                    b.corpBox('action', (ce) => {
                        ce.vSpace();
                        ce.action('Spend any number of energy to draw that many cards. Keep 1 and discard the rest.', (eb) => {
                            eb.text('X').energy(1).startAction.text('X').cards(1).nbsp(Size_1.Size.SMALL).text('KEEP 1');
                        });
                    });
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        return undefined;
    }
    canAct(player) {
        return player.energy > 0;
    }
    action(player) {
        return HiTechLab_1.HiTechLab.spendEnergyToDrawCards(player);
    }
}
exports.TychoMagnetics = TychoMagnetics;
//# sourceMappingURL=TychoMagnetics.js.map